import { Action, Mutation, Module, VuexModule } from 'vuex-module-decorators'
import { Actions, Mutations } from '@/store/enums/StoreEnums'
import type { BreadcrumbPathItem } from '@/core/helpers/breadcrumb'

interface Breadcrumb {
  title: string
  pageBreadcrumbPath: Array<BreadcrumbPathItem>
}

interface StoreInfo {
  breadcrumbs: Breadcrumb
}

@Module
export default class BreadcrumbsModule extends VuexModule implements StoreInfo {
  breadcrumbs = {} as Breadcrumb

  /**
   * Get breadcrumb object for current page
   * @returns object
   */
  get getBreadcrumbs(): Breadcrumb {
    return this.breadcrumbs
  }

  /**
   * Get breadcrumb array for current page
   * @returns object
   */
  get pageBreadcrumbPath(): Array<BreadcrumbPathItem> {
    return this.breadcrumbs.pageBreadcrumbPath
  }

  /**
   * Get current page title
   * @returns string
   */
  get pageTitle(): string {
    return this.breadcrumbs.title
  }

  @Mutation
  [Mutations.SET_BREADCRUMB_MUTATION](payload: Breadcrumb) {
    this.breadcrumbs = payload
  }

  @Action
  [Actions.SET_BREADCRUMB_ACTION](payload: Breadcrumb) {
    this.context.commit(Mutations.SET_BREADCRUMB_MUTATION, payload)
  }
}
